import { HereMapInterface } from "common/utils/Map";
import { Polyline, PolylineOptions } from "entities/map";

export class HerePolyline implements Polyline {
  private _map: HereMapInterface;
  private _polyline?: H.map.Polyline;

  constructor(map: HereMapInterface, options?: PolylineOptions) {
    this._map = map;
    this._createPolyline(map, options);
  }

  _createPolyline(map: HereMapInterface, options?: PolylineOptions) {
    const nativeMap: Here = map.getNativeMap();
    const lineString: H.geo.LineString = new window.H.geo.LineString();

    options?.path?.forEach(({ lat, lng }) =>
      lineString.pushPoint({
        //@ts-ignore
        lat,
        //@ts-ignore
        lng,
      })
    );

    if (nativeMap) {
      this._polyline = new window.H.map.Polyline(lineString, {
        style: {
          strokeColor: options?.strokeColor,
          lineWidth: 10,
        },
      });

      if (options?.zIndex) {
        //@ts-ignore
        this._polyline.setZIndex(options.zIndex);
      }

      nativeMap.addObject(this._polyline);
    }
  }

  delete() {
    this._map.getNativeMap().removeObject(this._polyline);
  }
}
